import Router from '@/layout/router/index.js'

export const resolveRouteByPath = (path) => {
  return Router.resolve(path).route
}

// 解析路由，筛选有用的路由信息
export const resolveRoute = (item, getRouteName) => {
  const route = resolveRouteByPath(item.path)
  let fullPath = route.fullPath
  // 外部的系统跳转到erp会带入token，需要清除token类型参数
  fullPath = fullPath.replace(/([?&])erpticket=[^&]*/, '$1erpticket=')
  return {
    name: route.name || item.name || (getRouteName && getRouteName(item.path)),
    meta: {
      ...route.meta,
      layout: false, // 兜底
      tag: item.tag // 存在tag被修改场景
    },
    path: route.path,
    fullPath
  }
}

// 过滤不需要存储的页签模块
export const filterTabs = (views, getRouteName) => {
  // 由于远程包路由文件异步加载，导致路由未初始化完成，从而获取不到 name tag等相关信息，所以这里需要存储完整的路由信息
  const tabs = views.map(item => {
    const route = resolveRoute(item, getRouteName)
    return route
  })

  // 过滤业务线路由
  return tabs.filter(route => {
    if (route.meta && route.meta.noKeepTab) {
      return false
    }
    return true
  })
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/tabs-utils.js